import { UserAccountBalanceRptConstants } from "../constants";

export function UserAccountBalanceRpt(state = {}, action) {
    switch (action.type) {
        case UserAccountBalanceRptConstants.LOADING_REQUEST:
            return {
                ...state,
                loading: action.isbool
            };
        case UserAccountBalanceRptConstants.GETALL_REQUEST:
            return {
                ...state,
                loading: true
            };
        case UserAccountBalanceRptConstants.GETALL_SUCCESS:
            return {
                ...state,
                items: action.datas
            };
        case UserAccountBalanceRptConstants.GETALL_FAILURE:
            return {
                ...state,
                error: action.error
            };
        case UserAccountBalanceRptConstants.GETEXPORT_REQUEST:
            return {
                ...state,
                exporting: true
            };
        case UserAccountBalanceRptConstants.GETEXPORT_SUCCESS:
            return {
                ...state,
                exportitems: action.datas
            };
        case UserAccountBalanceRptConstants.GETEXPORT_FAILURE:
            return {
                ...state,
                error: action.error
            };
        default:
            return state
    }

}